import { Component, OnInit } from '@angular/core';
import { BuildInfoService } from '../../services/build-info.service';

@Component({
  selector: 'app-build-details',
  templateUrl: './build-details.component.html',
  styleUrls: ['./build-details.component.less']
})
export class BuildDetailsComponent implements OnInit {
  buildInfo: any[] = [];
  groupedBuildInfo: { [serviceName: string]: any[] } = {};
  loading = true;
  error: string | null = null;
  tableData: any[] = [];
  paginatedData: any[] = [];
  currentPage = 1;
  pageSize = 10;
  totalElements = 0;
  gotoPageNumber: number | null = null;
  sortField: string | null = null;
  sortOrder: string | null = null;

  constructor(private buildInfoService: BuildInfoService) {}

  ngOnInit(): void {
    if (this.buildInfo && this.buildInfo.length > 0) {
      this.groupedBuildInfo = this.groupByServiceName(this.buildInfo);
      this.initializeTable();
      this.loading = false;
    } else {
      this.buildInfoService.getBuildInfo().subscribe({
        next: (data: any[]) => {
          this.buildInfo = data;
          this.groupedBuildInfo = this.groupByServiceName(data);
          this.initializeTable();
          this.loading = false;
        },
        error: () => {
          this.error = 'Failed to load build information';
          this.loading = false;
        }
      });
    }
  }

  private groupByServiceName(data: any[]) {
    return data.reduce((acc, item) => {
      const key = item.serviceName;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {} as { [key: string]: any[] });
  }

  get serviceNames(): string[] {
    return Object.keys(this.groupedBuildInfo);
  }

  get maxPages(): number {
    return Math.ceil(this.totalElements / this.pageSize);
  }

  private initializeTable(): void {
    this.tableData = this.getTableData();
    this.totalElements = this.tableData.length;
    this.updatePaginatedData();
  }

  private getTableData(): any[] {
    const data: any[] = [];
    Object.keys(this.groupedBuildInfo).forEach(service => {
      this.groupedBuildInfo[service].forEach(item => {
        data.push({ ...item, service });
      });
    });
    return data;
  }

  private updatePaginatedData(): void {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedData = this.tableData.slice(startIndex, endIndex);
  }

  onPageSizeChange(size: number): void {
    this.pageSize = size;
    this.currentPage = 1;
    this.updatePaginatedData();
  }

  changePagination(page: number): void {
    this.currentPage = page;
    this.updatePaginatedData();
  }

  goToPage(): void {
    if (this.gotoPageNumber && this.gotoPageNumber >= 1 && this.gotoPageNumber <= this.maxPages) {
      this.currentPage = this.gotoPageNumber;
      this.updatePaginatedData();
      this.gotoPageNumber = null;
    }
  }

  sort(event: any): void {
    const { key, value } = event;
    this.sortField = key;
    this.sortOrder = value;
    this.applySorting();
  }

  private applySorting(): void {
    if (!this.sortField || !this.sortOrder) {
      return;
    }

    this.tableData.sort((a, b) => {
      const aVal = a[this.sortField!];
      const bVal = b[this.sortField!];

      if (aVal < bVal) {
        return this.sortOrder === 'ascend' ? -1 : 1;
      }
      if (aVal > bVal) {
        return this.sortOrder === 'ascend' ? 1 : -1;
      }
      return 0;
    });

    this.currentPage = 1;
    this.updatePaginatedData();
  }
}
